var render = function (_h,_vm) {var _c=_vm._c;return _c('div',_vm._g({staticClass:"main-navigation-drawer__item",class:{'main-navigation-drawer__item--selected': _vm.props.selected}},_vm.listeners),[_c('span',{staticClass:"main-navigation-drawer__item__wrap"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }